import { Container} from "@mui/material";
import React from "react";
import { SectionWrapper } from "../../../Styles/style";

import arbscan from "../../../../assets/images/pulsex.png"
import telegram from "../../../../assets/images/pulsechain.png"
import dextools from "../../../../assets/images/dextool.png"
import { useTheme } from "@emotion/react";
import { JOiningLinks, Wrap } from "./Styles";

const S2_Links = () => {
  const theme = useTheme()
  return (
    <div>
      <SectionWrapper p="1.7rem 0" id="" bgColor={theme.textTertiary}>
        <Container maxWidth="xl">
          <Wrap>
            <a href="https://scan.pulsechain.com/address/0x60C89f5eC551350235388b33d10643d46CaBE907" target="blank" data-aos="fade-right" data-aos-easing="ease-in"
              data-aos-delay="400"
              data-aos-duration="500">
              <JOiningLinks loading="lazy" src={telegram} />
            </a>
            <a href="https://app.pulsex.com/swap?outputCurrency=0x60C89f5eC551350235388b33d10643d46CaBE907" target="blank" data-aos="zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="300"
              data-aos-duration="500"
              data-aos-offset="0">
              <JOiningLinks loading="lazy" src={arbscan} />
            </a>
            <a href="https://www.dextools.io/app/en/pulse/pair-explorer/0x71267038ec334a963ab7987f6df4cf8441977fce" target="blank" data-aos="fade-left" data-aos-easing="ease-in"
              data-aos-delay="400"
              data-aos-duration="500">
              <JOiningLinks loading="lazy" src={dextools} />
            </a>
          </Wrap>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default S2_Links;
